import { db } from '../../firebase';
import { doc, setDoc, serverTimestamp, addDoc, collection } from 'firebase/firestore';

// Service functions to persist consent without altering account creation logic

export async function saveConsentSettings({ userId, childUserId = null, accountType, consent, parentEmail }) {
  const settingsRef = doc(db, 'consentSettings', userId);
  const dataToSave = {
    userId,
    childUserId: childUserId || userId,
    accountType, // 'student', 'parent', 'ngo_admin'
    consent,
    parentEmail: parentEmail || null,
    updatedAt: serverTimestamp(),
  };
  
  console.log('💾 ConsentService: Saving to Firestore:', {
    documentId: userId,
    data: dataToSave
  });
  
  await setDoc(settingsRef, dataToSave, { merge: true });
  
  console.log('✅ ConsentService: Successfully saved to Firestore');
}

export async function logConsentAction({ parentId, childUserId, action, toggleName, value }) {
  await addDoc(collection(db, 'consentAudit'), {
    parentId,
    childUserId,
    action, // 'approve' | 'reject' | 'set_default'
    toggleName,
    value,
    createdAt: serverTimestamp(),
  });
}

// Placeholder hooks for notifications (to be implemented in backend functions)
export async function notifyParentOnChildToggle({ parentEmail, childUserId, toggleName, desiredValue }) {
  // call backend endpoint or cloud function
  try {
    await fetch('/api/consent/notify-parent', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ parentEmail, childUserId, toggleName, desiredValue }),
    });
  } catch (e) {
    console.warn('notifyParentOnChildToggle failed (stub):', e?.message);
  }
}


